module.exports = __webpack_public_path__ + "92667777ad7071c0ba95e40d73056bb4.gif";